export default __webpack_public_path__ + "static/media/mario9.202d407b.jpg";